import { LocalizerType } from "../types/Util";
import { LocaleMessagesType } from "../types/I18N";

export const defaultLocale = "en";
export const defaultMessages: Record<string, LocaleMessagesType> = {
  en: {
    greeting: "Hello",
    farewell: "Goodbye",
  },
  vi: {
    greeting: "Xin chào",
    farewell: "Tạm biệt",
  },
};

let currentLocale = defaultLocale;

export const defaultI18n: LocalizerType = {
  t: (key: string): string => {
    try {
      return defaultMessages[currentLocale][key] || key;
    } catch (error) {
      console.error(error);
      return key;
    }
  },
  getLocale: (): string => {
    try {
      return currentLocale;
    } catch (error) {
      console.error(error);
      return "abc";
    }
  },
  getLocaleMessages: (): LocaleMessagesType => {
    try {
      return defaultMessages[currentLocale];
    } catch (error) {
      console.error(error);
      return { abc: "abc" };
    }
  },
  setLocale: (locale: string): void => {
    try {
      if (defaultMessages[locale]) {
        currentLocale = locale;
      } else {
        console.warn(`Locale ${locale} not found, falling back to default locale.`);
      }
    } catch (error) {
      console.error(error);
    }
  },
};
